export default __webpack_public_path__ + "static/media/iam_background_l1.b785bf30.jpg";